import React from 'react';
import { PiPencilLineBold } from "react-icons/pi";
import { RxRulerSquare } from "react-icons/rx";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { MdForest } from "react-icons/md";

const StepSection = () => {
  return (
    <div className="min-h-screen py-8 px-4 md:px-16" id="contact">
      {/* Heading Section */}
      <div className="max-w-full mx-auto" style={{width: "1180px"}}>
        <h2 
          className="text-[56px] font-bold text-left "
          style={{
            textShadow: "-12px 10px 4px rgba(0, 0, 0, 0.3)", // Adjust values for shadow
          }}>
          How It Works
        </h2>
        <div className="my-20"></div>
      </div>

      {/* Content Section */}
      <div className="flex flex-wrap gap-6 justify-center max-w-full mx-auto"
        style={{
          width: "1180px",
          height: "708px",
          gap: "24px",
      }}>
        {/* Box 1: Input (Short) */}
        <div className="flex-1 min-w-[150px] max-w-[277px] h-[498px] border border-gray-300 shadow-xl font-light text-black rounded-lg p-8 flex flex-col items-start bg-white transform hover:scale-105 transition duration-300 ease-in-out shadow-[-10px_10px_10px_rgba(0,0,0,0.3),5px_-5px_5px_rgba(255,255,255,0.7)]">
          <div className="flex justify-center w-full">
            <img
            src= "/Home_Page_Icon_1.png"
            alt= "Input"
            className= "w-[135px] h-[120px] justify-center">
            </img>
          </div>
          <div className="my-4"></div>
          <div className="flex items-center mb-6">
            <span className="text-[24px] font-extrabold">1. Input</span>
          </div>
          <p className="text-left text-[18px] font-semibold">
            Through our user-friendly interfaces and intuitive tools, inputting carbon emission data has never been simpler.
          </p>
        </div>

        {/* Box 2: Metrics (Medium) */}
        <div className="flex-1 min-w-[150px] max-w-[277px] h-[564px] border border-gray-300 shadow-xl font-light text-black rounded-lg p-8 flex flex-col items-start bg-white transform hover:scale-105 transition duration-300 ease-in-out shadow-[-10px_10px_10px_rgba(0,0,0,0.3),5px_-5px_5px_rgba(255,255,255,0.7)]">
          <div className="flex justify-center w-full">
            <img
            src= "/Home_Page_Icon_2.png"
            alt= "Metrics"
            className= "w-[135px] h-[120px] justify-center">
            </img>
          </div>
          <div className="my-8"></div>
          <div className="flex items-center mb-6">
            <span className="text-[24px] font-extrabold">2. Metrics</span>
          </div>
          <p className="text-left text-[18px] font-semibold">
            Comprehensive carbon reporting metrics, enabling companies to track their carbon emissions and environmental impact accurately.
          </p>
        </div>

        {/* Box 3: Predict (Long) */}
        <div className="flex-1 min-w-[150px] max-w-[277px] h-[611px] border border-gray-300 shadow-xl font-light text-black rounded-lg p-8 flex flex-col items-start bg-white transform hover:scale-105 transition duration-300 ease-in-out shadow-[-10px_10px_10px_rgba(0,0,0,0.3),5px_-5px_5px_rgba(255,255,255,0.7)]">
          <div className="flex justify-center w-full">
            <img
            src= "/Home_Page_Icon_3.png"
            alt= "Predict"
            className= "w-[135px] h-[120px] justify-center">
            </img>
          </div>
          <div className="my-12"></div>
          <div className="flex items-center mb-6">
            <span className="text-[24px] font-extrabold">3. Predict</span>
          </div>
          <p className="text-left text-[18px] font-semibold">
            Analyzing current trends and patterns using AI models, providing valuable insights for proactive environmental management.
          </p>
        </div>

        {/* Box 4: Offset (Medium) */}
        <div className="flex-1 min-w-[150px] max-w-[277px] h-[659px] border border-gray-300 shadow-xl font-light text-black rounded-lg p-8 flex flex-col items-start bg-white transform hover:scale-105 transition duration-300 ease-in-out shadow-[-10px_10px_10px_rgba(0,0,0,0.3),5px_-5px_5px_rgba(255,255,255,0.7)]">
          <div className="flex justify-center w-full">
            <img
            src= "/Home_Page_Icon_4.png"
            alt= "Offset"
            className= "w-[135px] h-[120px] justify-center">
            </img>
          </div>
          <div className="my-16"></div>
          <div className="flex items-center mb-6">
            <span className="text-[24px] font-extrabold">4. Offset</span>
          </div>
          <p className="text-left text-[18px] font-semibold">
            Allows companies to decarbonize and balance their carbon footprint by investing in environmentally friendly projects.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepSection;
